import EnvironmentUtils from "../utils/environment.utils";

const siteUrl = EnvironmentUtils.SITE_URL.replace(/\/$/, "");

export const seoConfig = {
  siteName: "Too Far East Barber & Co.",
  title:
    "Hong Kong Barbershop in Central & Causeway Bay | Too Far East Barber & Co.",
  description:
    "Book men's haircuts, beard trims, and hot towel shaves at Too Far East Barber & Co., with barbershop locations in Central/Sheung Wan and Causeway Bay, Hong Kong.",
  siteUrl,
  locale: "en_HK",
  twitterHandle: "@toofareastbarber",
  twitterCardType: "summary_large_image",
  defaultImage: `${siteUrl}/logo512.png`,
  facebookPage: "https://www.facebook.com/toofareastbarber/",
  instagramPage: "https://www.instagram.com/toofareastbarber/",
  business: {
    name: "Too Far East Barber & Co.",
    email: "info@toofareastbarber.com",
    sameAs: [
      "https://www.facebook.com/toofareastbarber/",
      "https://www.instagram.com/toofareastbarber/",
    ],
    branches: [
      {
        id: `${siteUrl}/#sheung-wan`,
        name: "Too Far East Barber & Co. - Central | Sheung Wan",
        address: "G/F, 180 Wellington Street, Hong Kong",
        phone: "+852-5795-3579",
        mapUrl: "https://maps.app.goo.gl/maMfZXGJN1cXfouT7",
        bookingUrl: "https://toofareastbarbersheungwan.resurva.com/",
      },
      {
        id: `${siteUrl}/#causeway-bay`,
        name: "Too Far East Barber & Co. - Causeway Bay",
        address: "3/F, 14 Kai Chiu Road, Hong Kong",
        phone: "+852-9330-3851",
        mapUrl: "https://maps.app.goo.gl/HZPvh4o6NFMiXigu9",
        bookingUrl: "https://toofareastbarbercausewaybay.resurva.com/",
      },
    ],
  },
};

export type SeoConfig = typeof seoConfig;
